import React, {Fragment, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

import { iniciarEjercicioAction, setearUrlAction } from '../../actions/estadoEjercicioActions';
import { solicitarInformacionEjercicioAction } from '../../actions/solicitoInformacionEjercicioActions';
import useConfigAuth from '../../Hooks/useConfigAuth';

// css
import {Titulo, Consigna, Flex, BtnBottom} from '../Css/MetodosCSS/StyledMethods';

const Instrucciones = (props) => {

    const dispatch = useDispatch();

    const [config] = useConfigAuth();
    const url = useLocation();

    const {instrucciones} = props;

    const sesion = useSelector(state => state.ejercicio.sesion);
    const ejercicio = useSelector(state => state.ejercicio.ejercicio);
    const letra = useSelector(state => state.ejercicio.letra);
    const lista = useSelector(state => state.ejercicio.lista);
    const informacion = useSelector(state => state.informacion.info_DB);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);

    useEffect(() => {
        Swal.hideLoading();
    }, [informacion])

    const iniciar = e => {
        e.preventDefault();
        
        Swal.fire({
            title: '¿Iniciamos el ejercicio?',
            showCancelButton: true,
            confirmButtonColor: '#23AAAF',
            cancelButtonColor: '#514BBE',
            cancelButtonText: 'No',
            confirmButtonText: 'Si',
            didOpen: () => {
                if(ejercicio !== 'Introduccion' && ejercicio !== 'Repaso' && ejercicio !== 'FluidezVocales' && ejercicio !== 'LN45'  && ejercicio !== 'LEN15' && ejercicio !== 'M9' && ejercicio !== 'M13' && ejercicio !== 'M14' && ejercicio !== 'M19' && ejercicio !== 'M19Bis' && ejercicio !== 'M20' && ejercicio !== 'M20Bis' && ejercicio !== 'M21' && ejercicio !== 'M21Bis' && ejercicio !== 'M22' && ejercicio !== 'M22Bis' && ejercicio !== 'M23' && ejercicio !== 'M23Bis' && ejercicio !== 'M24' && ejercicio !== 'M24Bis' && ejercicio !== 'M25' && ejercicio !== 'M25Bis' && ejercicio !== 'M26' && ejercicio !== 'M26Bis' && ejercicio !== 'M27' && ejercicio !== 'M27Bis' && ejercicio !== 'M28' && ejercicio !== 'M28Bis' && ejercicio !== 'M29' && ejercicio !== 'M29Bis' && ejercicio !== 'M30' && ejercicio !== 'M30Bis' && ejercicio !== 'M31' && ejercicio !== 'M31Bis' && ejercicio !== 'M32' && ejercicio !== 'M32Bis' && ejercicio !== 'M86Bis' && ejercicio !== 'M33' && ejercicio !== 'M37' && ejercicio !== 'M40' && ejercicio !== 'M41' && ejercicio !== 'M43' && ejercicio !== 'M44' && ejercicio !== 'M45' && ejercicio !== 'M46' && ejercicio !== 'M47' && ejercicio !== 'M48' && ejercicio !== 'M49' && ejercicio !== 'M50' && ejercicio !== 'M52' && ejercicio !== 'M38' && ejercicio !== 'M87' && ejercicio !== 'M55' && ejercicio !== 'M55Bis' && ejercicio !== 'M56' && ejercicio !== 'M57' && ejercicio !== 'M58' && ejercicio !== 'M59' && ejercicio !== 'M60' && ejercicio !== 'M61' && ejercicio !== 'M61Bis' && ejercicio !== 'M61Practica' && ejercicio !== 'M62' && ejercicio !== 'M62Bis' && ejercicio !== 'M62Practica' && ejercicio !== 'M63' && ejercicio !== 'M63Bis' && ejercicio !== 'M63Practica' && ejercicio !== 'M64' && ejercicio !== 'M65' && ejercicio !== 'M67' && ejercicio !== 'M68' && ejercicio !== 'M70'  && ejercicio !== 'M71' && ejercicio !== 'M72' && ejercicio !== 'M73' && ejercicio !== 'M75' && ejercicio !== 'M76' && ejercicio !== 'M77' && ejercicio !== 'M78' && ejercicio !== 'M79' && ejercicio !== 'M80' && ejercicio !== 'M81' && ejercicio !== 'M82' && ejercicio !== 'M82Bis' && ejercicio !== 'M82Practica' && ejercicio !== 'M89' && ejercicio !== 'M89Bis' && ejercicio !== 'M89Practica' && ejercicio !== 'M83' && ejercicio !== 'M83Bis' && ejercicio !== 'M83Practica' && ejercicio !== 'M84' && ejercicio !== 'M84Bis' && ejercicio !== 'M84Practica' && ejercicio !== 'M85' && ejercicio !== 'M90' && ejercicio !== 'M120' && ejercicio !== 'M121' && ejercicio !== 'M150' && ejercicio !== 'M151' && ejercicio !== 'M152' && ejercicio !== 'M153' && ejercicio !== 'M154' && ejercicio !== 'M155' && ejercicio !== 'M156' && ejercicio !== 'M157' && ejercicio !== 'M158'){
                    Swal.showLoading();
                    const informacion = {
                        config,
                        payload: {
                            ejercicio, 
                            letra, 
                            lista, 
                            id_paciente,
                            sesion,
                            inicia_ejercicio: true
                        }
                    }
                    dispatch( solicitarInformacionEjercicioAction(informacion) );
                }
            }
          }).then((result) => {
            if (result.isConfirmed) {
                dispatch( iniciarEjercicioAction() )
                dispatch( setearUrlAction(url.pathname));
            }
          })
    }

    return (
        <Fragment>
            <Flex $flexgrow="1" direction="column" align="center" >
                <Titulo>Consigna:</Titulo>
                <Consigna>{instrucciones}</Consigna>
                <BtnBottom margin="50px"
                    onClick={iniciar}
                >
                    <img alt='' src={`/img/play.png`}/>
                </BtnBottom>
            </Flex>
        </Fragment>

    );
}
 
export default Instrucciones;